import React, { useEffect, useState } from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'
import axios from 'axios';
import { count } from 'console';
import { CiCalendar } from 'react-icons/ci';
import { FiClock } from 'react-icons/fi';

interface NewsStructure {
    id:string;
    title:string;
    img:string;
    desc:string;
    date:string;
  }
const AllNews = () => {
    const api = process.env.REACT_APP_API_URL as string;
      const [newData, setNewData] = useState<NewsStructure[]>([]);
      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get<NewsStructure[]>(
              `${api}/auth/news`
            );
    
            //console.log('news data',response.data)
            setNewData(response.data);
            //console.log("news data in a array",newData);
          } catch (error) {
            console.error("Post Not Found:", error);
          }
        };
    
        fetchData();
      }, []);
  return (
    <div>
         <Header />

         <div className="w-full bg-gradient-to-b from-[#1B1E23] to-[#2E3238] p-10">
  {/* Featured Story Section */}
  <div className="w-full flex flex-col lg:flex-row gap-5">
  <div className="lg:w-[70%] w-full relative group rounded-2xl cursor-pointer overflow-hidden shadow-lg" onClick={() => {
            window.location.href = `/blog/${newData[0].title}`;
          }}>
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent opacity-100 transition-all duration-500 z-10"></div>
    <img
      className="w-full h-[450px] object-cover rounded-2xl transition-transform duration-500 group-hover:scale-105"
      src={`${api}/${newData[0]?.img}`}
      alt="Featured Story"
    />
    <div className="absolute bottom-8 left-8 z-20">
      <span className="bg-[#FE4B23] text-white text-sm px-3 py-1 rounded-full">
        Featured Story
      </span>
      <h2 className="text-[32px] font-bold text-white mt-3">{newData[0]?.title}</h2>
      <span className="text-sm text-gray-300 block mt-1">
        {newData[0]?.date.substring(0, 10)}
      </span>
      <p className="text-gray-300 mt-2 text-lg">{newData[0]?.desc}</p>
    </div>
  </div>

    {/* Right Side News List */}
    <div className="lg:w-[30%] w-full flex flex-col gap-5">
      {newData.slice(0, 5).map((data, index) => (
        <div
          key={index}
          className="flex items-center gap-3 bg-[#2B3543] p-3 rounded-lg shadow-lg transition-all hover:bg-[#465468] hover:scale-[1.03] cursor-pointer"
          onClick={() => {
            window.location.href = `/blog/${data.title}`;
          }}
        >
          <img
            className="w-[30%] h-[80px] rounded-lg object-cover"
            src={`${api}/${data.img}`}
            alt={`News ${index + 1}`}
          />
          <div>
            <span className="text-[#94A2B8] text-[13px] font-light">
              {data.date.substring(0, 10)}
            </span>
            <h4 className="text-white text-[16px] font-medium mt-1">
              {data.title}
            </h4>
          </div>
        </div>
      ))}
    </div>
  </div>

  {/* Top Stories Section */}
  <div className="mt-10">
  <h2 className="text-[24px] font-bold text-white">Top Stories</h2>
  <div className="flex flex-wrap gap-5 justify-center sm:justify-between mt-5">
    {newData.slice(0, 8).map((data, index) => (
      <div
        key={index}
        className="bg-[#344056] border border-[#64748B] rounded-2xl p-5 relative w-full sm:w-[48%] lg:w-[32%] shadow-lg transition-all hover:scale-[1.02] hover:border-[#FDBC12]"
      >
        <button className="bg-[#FDBC12] text-[#101729] font-[13px] rounded-tr-[16px] absolute top-[20px] right-[20px] py-2 px-3">
          News
        </button>
        <img
          className="rounded-t-2xl w-full h-[180px] object-cover"
          src={`${api}/${data.img}`}
          alt={`Top Story ${index + 1}`}
        />
        <div className="flex justify-between my-5">
          <div className="flex items-center">
            <CiCalendar className="text-[#94A2B8]" />
            <span className="text-[#94A2B8] font-thin ml-1">
              {data.date.substring(0, 10)}
            </span>
          </div>
          <div className="flex items-center">
            <FiClock className="text-[#94A2B8]" />
            <span className="text-[#94A2B8] font-thin ml-1">5 Min Read</span>
          </div>
        </div>
        <h3 className="text-white text-[18px] font-semibold">{data.title}</h3>
        <button
          className="w-full bg-[#465468] py-3 border border-[#64748B] rounded-lg text-[#D7D3D2] text-[16px] mt-4 hover:bg-[#FDBC12] hover:text-[#101729] hover:border-[#FDBC12]"
          onClick={() => {
            window.location.href = `/blog/${data.title}`;
          }}
        >
          Read More
        </button>
      </div>
    ))}
  </div>
</div>


</div>


         <Footer />
    </div>
  )
}

export default AllNews